export default "__VITE_ASSET__TdRpZahJ__"